import React from "react";
import { FaMagnifyingGlass } from "react-icons/fa6";
import Dropdown from "react-bootstrap/Dropdown";
import { FaLocationDot } from "react-icons/fa6";
import { GiHouse } from "react-icons/gi";
import { FaMoneyBillAlt } from "react-icons/fa";
import { IoMdInformationCircle } from "react-icons/io";
import { FaRegCalendar } from "react-icons/fa";

import { FaArrowRightLong } from "react-icons/fa6";
import featureImg1 from "../../assets/images/home/fp1.png";
import featureImg2 from "../../assets/images/home/fp2.png";
import featureImg3 from "../../assets/images/home/fp3.png";
import { FaBuilding } from "react-icons/fa";
import { IoBed } from "react-icons/io5";
import { FaBath } from "react-icons/fa6";
import { Link } from "react-router-dom";

export const BrowseProperties = () => {
  return (
    <div className="browseContainer">
      <div className="container">
        <div className="searchContainer">
          <input type="text" placeholder="Search For A Property" />
          <button>
            <FaMagnifyingGlass/>
          <span className="btnFindText">Find Property</span>
          </button>
        </div>
        <div className="filterContainerGrid">
          <div>
            <Dropdown className="filterDropdown">
              <Dropdown.Toggle id="dropdown-basic">
                <span className="me-2">
                  <FaLocationDot />
                </span>
                Location
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item href="#/action-1">---</Dropdown.Item>
                <Dropdown.Item href="#/action-2">---</Dropdown.Item>
                <Dropdown.Item href="#/action-3">---</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <div>
            <Dropdown className="filterDropdown">
              <Dropdown.Toggle id="dropdown-basic">
                <span className="me-2">
                  <GiHouse />
                </span>
                Property Type
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item href="#/action-1">---</Dropdown.Item>
                <Dropdown.Item href="#/action-2">---</Dropdown.Item>
                <Dropdown.Item href="#/action-3">---</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <div>
            <Dropdown className="filterDropdown">
              <Dropdown.Toggle id="dropdown-basic">
                <span className="me-2">
                  <FaMoneyBillAlt />
                </span>
                Pricing Range
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item href="#/action-1">---</Dropdown.Item>
                <Dropdown.Item href="#/action-2">---</Dropdown.Item>
                <Dropdown.Item href="#/action-3">---</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <div>
            <Dropdown className="filterDropdown">
              <Dropdown.Toggle id="dropdown-basic">
                <span className="me-2">
                  <IoMdInformationCircle />
                </span>
                Bidding Status
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item href="#/action-1">---</Dropdown.Item>
                <Dropdown.Item href="#/action-2">---</Dropdown.Item>
                <Dropdown.Item href="#/action-3">---</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <div>
            <Dropdown className="filterDropdown">
              <Dropdown.Toggle id="dropdown-basic">
                <span className="me-2">
                  <FaRegCalendar />
                </span>
                Build Year
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item href="#/action-1">---</Dropdown.Item>
                <Dropdown.Item href="#/action-2">---</Dropdown.Item>
                <Dropdown.Item href="#/action-3">---</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      </div>

      {/* property cards  */}
      <div className="featuredContainer">
        <div className="container">
          <div className="featureTitle">
            Browse Verified Properties. Show Interest When Ready.
          </div>
          <div className="trendContainer">
            <div>
              At SnapBid, every property you see is verified, visit-ready, and
              free from pressure. You don’t need to sign up just to browse —
              express interest only when you’re genuinely considering it. From
              that point, we’ll guide you through site visits and offline
              bidding with other serious buyers.
            </div>
            <div>
              <a href="#">
                {" "}
                View All Properties <FaArrowRightLong />
              </a>
            </div>
          </div>
          <div className="featureCardGrid">
            <div className="featureCard">
              <div className="featureImg">
                <img src={featureImg1} />
              </div>
              <div className="featureCardContent">
                <div>Serenity Villa</div>
                <div>
                  A stunning 4-bedroom, 3-bathroom villa in a peaceful suburban
                  neighborhood...
                </div>
              </div>
              <div className="featureMenu">
                <div>
                  <span className="pe-1">
                    <IoBed />
                  </span>
                  4-Bedroom
                </div>
                <div>
                  <span className="pe-1">
                    <FaBath />
                  </span>
                  3-Bathroom
                </div>
                <div>
                  <span className="pe-1">
                    <FaBuilding />
                  </span>
                  Villa
                </div>
              </div>
              <div className="priceContainer">
                <div>
                  <div className="textPrice">Price</div>
                  <div className="textRupee">
                    <span>₹55,00,000</span>
                    <span>
                      <strike>₹65,00,000</strike>
                    </span>
                  </div>
                </div>
                <div>
                  <div>&nbsp;</div>
                  <Link to="/bidding-property-details">  <button className="btnView">View Details</button></Link>
                
                </div>
              </div>
            </div>

            <div className="featureCard">
              <div className="featureImg">
                <img src={featureImg2} />
              </div>
              <div className="featureCardContent">
                <div>Serenity Villa</div>
                <div>
                  A stunning 4-bedroom, 3-bathroom villa in a peaceful suburban
                  neighborhood...
                </div>
              </div>
              <div className="featureMenu">
                <div>
                  <span className="pe-1">
                    <IoBed />
                  </span>
                  4-Bedroom
                </div>
                <div>
                  <span className="pe-1">
                    <FaBath />
                  </span>
                  3-Bathroom
                </div>
                <div>
                  <span className="pe-1">
                    <FaBuilding />
                  </span>
                  Villa
                </div>
              </div>
              <div className="priceContainer">
                <div>
                  <div className="textPrice">Price</div>
                  <div className="textRupee">
                    <span>₹55,00,000</span>
                    <span>
                      <strike>₹65,00,000</strike>
                    </span>
                  </div>
                </div>
                <div>
                  <div>&nbsp;</div>
                  <button className="btnView">View Details</button>
                </div>
              </div>
            </div>

            <div className="featureCard">
              <div className="featureImg">
                <img src={featureImg3} />
              </div>
              <div className="featureCardContent">
                <div>Serenity Villa</div>
                <div>
                  A stunning 4-bedroom, 3-bathroom villa in a peaceful suburban
                  neighborhood...
                </div>
              </div>
              <div className="featureMenu">
                <div>
                  <span className="pe-1">
                    <IoBed />
                  </span>
                  4-Bedroom
                </div>
                <div>
                  <span className="pe-1">
                    <FaBath />
                  </span>
                  3-Bathroom
                </div>
                <div>
                  <span className="pe-1">
                    <FaBuilding />
                  </span>
                  Villa
                </div>
              </div>
              <div className="priceContainer">
                <div>
                  <div className="textPrice">Price</div>
                  <div className="textRupee">
                    <span>₹55,00,000</span>
                    <span>
                      <strike>₹65,00,000</strike>
                    </span>
                  </div>
                </div>
                <div>
                  <div>&nbsp;</div>
                  <button className="btnView">View Details</button>
                </div>
              </div>
            </div>

            <div className="featureCard">
              <div className="featureImg">
                <img src={featureImg1} />
              </div>
              <div className="featureCardContent">
                <div>Serenity Villa</div>
                <div>
                  A stunning 4-bedroom, 3-bathroom villa in a peaceful suburban
                  neighborhood...
                </div>
              </div>
              <div className="featureMenu">
                <div>
                  <span className="pe-1">
                    <IoBed />
                  </span>
                  4-Bedroom
                </div>
                <div>
                  <span className="pe-1">
                    <FaBath />
                  </span>
                  3-Bathroom
                </div>
                <div>
                  <span className="pe-1">
                    <FaBuilding />
                  </span>
                  Villa
                </div>
              </div>
              <div className="priceContainer">
                <div>
                  <div className="textPrice">Price</div>
                  <div className="textRupee">
                    <span>₹55,00,000</span>
                    <span>
                      <strike>₹65,00,000</strike>
                    </span>
                  </div>
                </div>
                <div>
                  <div>&nbsp;</div>
                  <button className="btnView">View Details</button>
                </div>
              </div>
            </div>

            <div className="featureCard">
              <div className="featureImg">
                <img src={featureImg2} />
              </div>
              <div className="featureCardContent">
                <div>Serenity Villa</div>
                <div>
                  A stunning 4-bedroom, 3-bathroom villa in a peaceful suburban
                  neighborhood...
                </div>
              </div>
              <div className="featureMenu">
                <div>
                  <span className="pe-1">
                    <IoBed />
                  </span>
                  4-Bedroom
                </div>
                <div>
                  <span className="pe-1">
                    <FaBath />
                  </span>
                  3-Bathroom
                </div>
                <div>
                  <span className="pe-1">
                    <FaBuilding />
                  </span>
                  Villa
                </div>
              </div>
              <div className="priceContainer">
                <div>
                  <div className="textPrice">Price</div>
                  <div className="textRupee">
                    <span>₹55,00,000</span>
                    <span>
                      <strike>₹65,00,000</strike>
                    </span>
                  </div>
                </div>
                <div>
                  <div>&nbsp;</div>
                  <button className="btnView">View Details</button>
                </div>
              </div>
            </div>

            <div className="featureCard">
              <div className="featureImg">
                <img src={featureImg3} />
              </div>
              <div className="featureCardContent">
                <div>Serenity Villa</div>
                <div>
                  A stunning 4-bedroom, 3-bathroom villa in a peaceful suburban
                  neighborhood...
                </div>
              </div>
              <div className="featureMenu">
                <div>
                  <span className="pe-1">
                    <IoBed />
                  </span>
                  4-Bedroom
                </div>
                <div>
                  <span className="pe-1">
                    <FaBath />
                  </span>
                  3-Bathroom
                </div>
                <div>
                  <span className="pe-1">
                    <FaBuilding />
                  </span>
                  Villa
                </div>
              </div>
              <div className="priceContainer">
                <div>
                  <div className="textPrice">Price</div>
                  <div className="textRupee">
                    <span>₹55,00,000</span>
                    <span>
                      <strike>₹65,00,000</strike>
                    </span>
                  </div>
                </div>
                <div>
                  <div>&nbsp;</div>
                  <button className="btnView">View Details</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* without bidding cards  */}
      <div className="featuredContainer">
        <div className="container">
          <div className="featureTitle">Buy Without Bidding</div>
          <div className="trendContainer">
            <div>
              Looking for a quicker way to buy your next home or plot? SnapBid
              now features select properties available for immediate purchase at
              a fixed price — no bidding, no delays. All listings are verified,
              and you can connect with us directly to move forward confidently.
            </div>
            <div>
              <a href="#">
                {" "}
                View All Properties <FaArrowRightLong />
              </a>
            </div>
          </div>
          <div className="featureCardGrid">
            <div className="featureCard">
              <div className="featureImg">
                <img src={featureImg1} />
              </div>
              <div className="featureCardContent">
                <div>Serenity Villa</div>
                <div>
                  A stunning 4-bedroom, 3-bathroom villa in a peaceful suburban
                  neighborhood...
                </div>
              </div>
              <div className="featureMenu">
                <div>
                  <span className="pe-1">
                    <IoBed />
                  </span>
                  4-Bedroom
                </div>
                <div>
                  <span className="pe-1">
                    <FaBath />
                  </span>
                  3-Bathroom
                </div>
                <div>
                  <span className="pe-1">
                    <FaBuilding />
                  </span>
                  Villa
                </div>
              </div>
              <div className="priceContainer">
                <div>
                  <div className="textPrice">Price</div>
                  <div className="textRupee">
                    <span>₹55,00,000</span>
                    <span>
                      <strike>₹65,00,000</strike>
                    </span>
                  </div>
                </div>
                <div>
                  <div>&nbsp;</div>
                  <Link to="/without-bidding-property"><button className="btnView">View Details</button></Link>
                  
                </div>
              </div>
            </div>

            <div className="featureCard">
              <div className="featureImg">
                <img src={featureImg2} />
              </div>
              <div className="featureCardContent">
                <div>Serenity Villa</div>
                <div>
                  A stunning 4-bedroom, 3-bathroom villa in a peaceful suburban
                  neighborhood...
                </div>
              </div>
              <div className="featureMenu">
                <div>
                  <span className="pe-1">
                    <IoBed />
                  </span>
                  4-Bedroom
                </div>
                <div>
                  <span className="pe-1">
                    <FaBath />
                  </span>
                  3-Bathroom
                </div>
                <div>
                  <span className="pe-1">
                    <FaBuilding />
                  </span>
                  Villa
                </div>
              </div>
              <div className="priceContainer">
                <div>
                  <div className="textPrice">Price</div>
                  <div className="textRupee">
                    <span>₹55,00,000</span>
                    <span>
                      <strike>₹65,00,000</strike>
                    </span>
                  </div>
                </div>
                <div>
                  <div>&nbsp;</div>
                  <button className="btnView">View Details</button>
                </div>
              </div>
            </div>

            <div className="featureCard">
              <div className="featureImg">
                <img src={featureImg3} />
              </div>
              <div className="featureCardContent">
                <div>Serenity Villa</div>
                <div>
                  A stunning 4-bedroom, 3-bathroom villa in a peaceful suburban
                  neighborhood...
                </div>
              </div>
              <div className="featureMenu">
                <div>
                  <span className="pe-1">
                    <IoBed />
                  </span>
                  4-Bedroom
                </div>
                <div>
                  <span className="pe-1">
                    <FaBath />
                  </span>
                  3-Bathroom
                </div>
                <div>
                  <span className="pe-1">
                    <FaBuilding />
                  </span>
                  Villa
                </div>
              </div>
              <div className="priceContainer">
                <div>
                  <div className="textPrice">Price</div>
                  <div className="textRupee">
                    <span>₹55,00,000</span>
                    <span>
                      <strike>₹65,00,000</strike>
                    </span>
                  </div>
                </div>
                <div>
                  <div>&nbsp;</div>
                  <button className="btnView">View Details</button>
                </div>
              </div>
            </div>

            <div className="featureCard">
              <div className="featureImg">
                <img src={featureImg1} />
              </div>
              <div className="featureCardContent">
                <div>Serenity Villa</div>
                <div>
                  A stunning 4-bedroom, 3-bathroom villa in a peaceful suburban
                  neighborhood...
                </div>
              </div>
              <div className="featureMenu">
                <div>
                  <span className="pe-1">
                    <IoBed />
                  </span>
                  4-Bedroom
                </div>
                <div>
                  <span className="pe-1">
                    <FaBath />
                  </span>
                  3-Bathroom
                </div>
                <div>
                  <span className="pe-1">
                    <FaBuilding />
                  </span>
                  Villa
                </div>
              </div>
              <div className="priceContainer">
                <div>
                  <div className="textPrice">Price</div>
                  <div className="textRupee">
                    <span>₹55,00,000</span>
                    <span>
                      <strike>₹65,00,000</strike>
                    </span>
                  </div>
                </div>
                <div>
                  <div>&nbsp;</div>
                  <button className="btnView">View Details</button>
                </div>
              </div>
            </div>

            <div className="featureCard">
              <div className="featureImg">
                <img src={featureImg2} />
              </div>
              <div className="featureCardContent">
                <div>Serenity Villa</div>
                <div>
                  A stunning 4-bedroom, 3-bathroom villa in a peaceful suburban
                  neighborhood...
                </div>
              </div>
              <div className="featureMenu">
                <div>
                  <span className="pe-1">
                    <IoBed />
                  </span>
                  4-Bedroom
                </div>
                <div>
                  <span className="pe-1">
                    <FaBath />
                  </span>
                  3-Bathroom
                </div>
                <div>
                  <span className="pe-1">
                    <FaBuilding />
                  </span>
                  Villa
                </div>
              </div>
              <div className="priceContainer">
                <div>
                  <div className="textPrice">Price</div>
                  <div className="textRupee">
                    <span>₹55,00,000</span>
                    <span>
                      <strike>₹65,00,000</strike>
                    </span>
                  </div>
                </div>
                <div>
                  <div>&nbsp;</div>
                  <button className="btnView">View Details</button>
                </div>
              </div>
            </div>

            <div className="featureCard">
              <div className="featureImg">
                <img src={featureImg3} />
              </div>
              <div className="featureCardContent">
                <div>Serenity Villa</div>
                <div>
                  A stunning 4-bedroom, 3-bathroom villa in a peaceful suburban
                  neighborhood...
                </div>
              </div>
              <div className="featureMenu">
                <div>
                  <span className="pe-1">
                    <IoBed />
                  </span>
                  4-Bedroom
                </div>
                <div>
                  <span className="pe-1">
                    <FaBath />
                  </span>
                  3-Bathroom
                </div>
                <div>
                  <span className="pe-1">
                    <FaBuilding />
                  </span>
                  Villa
                </div>
              </div>
              <div className="priceContainer">
                <div>
                  <div className="textPrice">Price</div>
                  <div className="textRupee">
                    <span>₹55,00,000</span>
                    <span>
                      <strike>₹65,00,000</strike>
                    </span>
                  </div>
                </div>
                <div>
                  <div>&nbsp;</div>
                  <button className="btnView">View Details</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
